import {Component, HostBinding, input} from '@angular/core';
import {Button} from "primeng/button";
import {Popover} from "primeng/popover";
import {PageTitleLayoutComponent} from "../page-title-layout/page-title-layout.component";

@Component({
  selector: 'homey-form-page',
  standalone: true,
  imports: [
    Button,
    Popover,
    PageTitleLayoutComponent
  ],
  templateUrl: './form-page.component.html',
  styleUrl: './form-page.component.scss'
})
export class FormPageComponent {
  @HostBinding('class') readonly class = 'flex flex-col flex-grow';
  stepInfo = input.required<{ current: number, total: number } | null>();
  title = input.required<string>();
  subtitle = input<string>();
  titleInvisible = input(false);
  extraInfo = input<string>();
}
